import { DriverIdDTO, DriverIdPath, DriverIdPathRuntype } from '@luminovo/api-contracts';

/**
 * We want to add whether an id is a user or system id.
 *
 * */
export const formatDriverIdPath = (driverId: DriverIdDTO): DriverIdPath => {
    return DriverIdPathRuntype.parse(`${driverId.type.toLowerCase()}|${driverId.value}`);
};
